import React from "react";
import * as actions from '../Actions';
import './WeekSlider.css';

function getWeekClass(eleRef, result, weekKey) {
    if (eleRef.state.currentweek == parseInt(result[weekKey]) && (eleRef.state.IsExpected && global.ftk != "") && eleRef.state.clickwedWeek == parseInt(result[weekKey])) {
        return "current_li sel-week";
    } else if (eleRef.state.currentweek == parseInt(result[weekKey]) && (eleRef.state.IsExpected && global.ftk != "") && eleRef.state.clickwedWeek != parseInt(result[weekKey])) {
        return "current_li";
    } else if (eleRef.state.clickwedWeek == parseInt(result[weekKey])) {
        return "sel-week";
    } else {
        return "";
    }
}

export default function WeekSlider({ eleRef, WeekBdata, weekKey, keyVal, tool }) {
    return (
        <div className="week-slider">
            <div className="weeks-section" id="slide_block">
                <ul className="week-bar" id="profiles_block">
                    {WeekBdata && WeekBdata.length > 0 && WeekBdata.map(result =>
                        <li key={parseInt(result[weekKey])} id={'week_' + parseInt(result[weekKey])} className={getWeekClass(eleRef, result, weekKey)} onClick={() => { actions.weekInfo((parseInt(result[weekKey])), eleRef, keyVal, tool) }}>
                            <div className="allweeks" id={parseInt(result[weekKey])}>
                                {tool == 'pis' && <span className="wk-line"></span>}
                                <span className="week" id={parseInt(result[weekKey])}>
                                    <span className="weeknum">{parseInt(result[weekKey])}</span>
                                </span>
                                {eleRef.state.currentweek == parseInt(result[weekKey]) && (eleRef.state.IsExpected && global.ftk != "") ?
                                    <span className="wk-txt">Current <br /> Week</span>
                                    :
                                    <span className="wk-txt"> Week</span>
                                }
                            </div>
                        </li>
                    )}
                </ul>
            </div>
            <span className="week-next" data-icon-font="h" onClick={() => { actions.slideRight(eleRef.state.clickwedWeek, keyVal, eleRef, tool) }}></span>
            <span className="week-prev" data-icon-font="g" onClick={() => { actions.slideLeft(eleRef.state.clickwedWeek, keyVal, eleRef, tool) }}></span>
        </div>
    );
}



// WEBPACK FOOTER //
// src/shared/tools/common/WeekSlider.js